// src/api/dummyApi.js

// --- Dummy Data ---
const dummyOrgDetails = {
    name: "Green Valley Lab Inc.",
    location: "123 Research Road, Science City",
    dateEstablished: "2010-05-15", // YYYY-MM-DD for date input
    mandate: "To provide accurate and timely diagnostic services.",
    rcNumber: "RC12345678",
    brandName: "GreenLab",
    stateId: 2, // Corresponds to 'Lagos' in dummyStates
    lgaId: 5, // Corresponds to 'Ikeja' in dummyLgas
    phone: "+2348012345678",
    email: "info@greenlab.com",
    website: "https://www.greenlab.com",
    logoPath: "/images/greenlab_logo.png",
    cacPath: "/docs/greenlab_cac.pdf",
  };
  
  const dummyContactPerson = {
    id: 1,
    firstName: "Jane",
    lastName: "Doe",
    designation: "Lab Manager",
    phoneNumber: "+2349011223344",
    email: "jane.doe@greenlab.com",
  };
  
  const dummyAboutLab = {
    healthCareProviderId: 101,
    labDetails: "Green Valley Lab is a leading diagnostic center equipped with state-of-the-art technology and highly skilled professionals dedicated to patient care.",
    workDays: "Mon-Sat",
    workHours: "8:00 AM - 6:00 PM",
    thingToKnow: "Appointments are recommended for specialized tests. Fasting required for certain blood tests.",
    healthCareProviderPaymentOptions: [
      { id: 1, paymentOptionsId: 1, paymentOptionName: "Cash" }, // Adding paymentOptionName for convenience
      { id: 2, paymentOptionsId: 3, paymentOptionName: "Bank Transfer" },
    ],
  };
  
  const dummyStates = [
    { id: 1, name: "Abuja FCT" },
    { id: 2, name: "Lagos" },
    { id: 3, name: "Rivers" },
  ];
  
  const dummyLgas = [
    { id: 1, stateId: 1, name: "Abuja Municipal" },
    { id: 2, stateId: 1, name: "Bwari" },
    { id: 3, stateId: 2, name: "Badagry" },
    { id: 4, stateId: 2, name: "Epe" },
    { id: 5, stateId: 2, name: "Ikeja" },
    { id: 6, stateId: 3, name: "Port Harcourt" },
    { id: 7, stateId: 3, name: "Obio-Akpor" },
  ];
  
  const dummyPaymentOptions = [
    { id: 1, name: "Cash" },
    { id: 2, name: "POS" },
    { id: 3, name: "Bank Transfer" },
    { id: 4, name: "Online Payment" },
    { id: 5, name: "Insurance" },
  ];
  
  // --- API Simulation Functions ---
  
  const simulateApiCall = (data, delay = 800) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, data: data });
      }, delay);
    });
  };
  
  const simulateApiError = (message, delay = 800) => {
    return new Promise((_, reject) => {
      setTimeout(() => {
        reject({ success: false, message: message || "An API error occurred." });
      }, delay);
    });
  };
  
  
  // Org Details API
  export const fetchOrgDetails = () => simulateApiCall(dummyOrgDetails);
  export const updateOrgDetails = (data) => {
    console.log("Updating Org Details:", data);
    // In a real app, you'd send `data` to your backend
    return simulateApiCall({ ...dummyOrgDetails, ...data });
  };
  
  // Contact Person API
  export const fetchContactPerson = () => simulateApiCall(dummyContactPerson);
  export const updateContactPerson = (data) => {
    console.log("Updating Contact Person:", data);
    return simulateApiCall({ ...dummyContactPerson, ...data });
  };
  
  // About Lab API
  export const fetchAboutLab = () => simulateApiCall(dummyAboutLab);
  export const updateAboutLab = (data) => {
    console.log("Updating About Lab:", data);
    return simulateApiCall({ ...dummyAboutLab, ...data });
  };
  
  // General Data Fetching API (for dropdowns)
  export const fetchStates = () => simulateApiCall(dummyStates);
  export const fetchLgasByState = (stateId) => {
    return simulateApiCall(dummyLgas.filter(lga => lga.stateId === stateId));
  };
  export const fetchPaymentOptions = () => simulateApiCall(dummyPaymentOptions);

  export const uploadImage = (file) => {
    console.log("Simulating image upload for:", file.name);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Simulate success and return a dummy URL
        if (file && file.size < 5 * 1024 * 1024) { // Max 5MB dummy check
          // In a real app, you'd get the actual CDN/server path here
          
          const dummyUrl = `/uploads/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;
          resolve({ success: true, url: dummyUrl });
        } else {
          reject({ success: false, message: "File too large or invalid." });
        }
      }, 1500); // Simulate network delay
    });
  };